import { Component, OnInit, Input,SimpleChanges } from '@angular/core';
import { environment } from '../../../../../../environments/environment';
import { LocalStorageService } from 'ngx-webstorage';
import { ExcessProtect } from 'src/app/model/quote/excessprotect/excessprotect.model';
import { ExcessProtectService } from '../../../excess.service';
import { QuoteService } from '../../../../quote.service';

@Component({
  selector: 'app-excess-protect-overview',
  templateUrl: './excess-protect-overview.component.html',
  styleUrls: ['./excess-protect-overview.component.css']
})
export class ExcessProtectOverviewComponent implements OnInit {

  quote;
  quoteApplicationData = new ExcessProtect();
  CoverTo;
  coverLimitOptions = [];
  transction_type = '';
  @Input() set quoteDetails(value: any) {
    if (value) {
      this.quote = value;
      this.quoteApplicationData = value;
      let maxDate = new Date(value.policy_start_date).setFullYear(new Date(value.policy_start_date).getFullYear() + 1);
      this.CoverTo = new Date(new Date(maxDate).getTime() - (24 * 60 * 60 * 1000));
      const proposerType = value.policy_holder?.proposer_type;

      if (proposerType) {
        if (proposerType == 1) {
          this.quote.policy_holder.proposer_type = 'individual';
        }
        else if (proposerType == 2) {
          this.quote.policy_holder.proposer_type = 'joint';
        }
        else {
          this.quote.policy_holder.proposer_type = 'company';
        }
      }
    }
  }

  constructor(private sessionSt: LocalStorageService, private excessProtectService: ExcessProtectService, private quoteService: QuoteService) { }
  isAdmin = false;
  ngOnInit(): void {
    if (this.sessionSt.retrieve('is_admin')) {
      this.isAdmin = true;
    }
    this.getExcessProtectOptionsList();
    this.getQuoteTypes();
  }
  ngOnChanges(changes: SimpleChanges) {
    this.getQuoteTypes();
  }
  public getExcessProtectOptionsList() {
    // GET UNIQUE ID FOR DRIVERS
    this.excessProtectService.getExcessProtectOptions()
      .subscribe(
        (response: any) => {
          if (response) {
            this.coverLimitOptions = response;
            this.coverLimitOptions = response.result.map(option => ({
              ...option,

            }));
          }
        },
        (error) => { }
      );
  }
  getCoverLimitName(optionId: number): string {
    const option = this.coverLimitOptions?.find(opt => opt.id === optionId);

    if (!option?.name) {
      return '';
    }

    const match = option.name.match(/£([0-9,]+)/);

    return match ? match[1].replace(/,/g, '') : '';
  }

  getQuoteTypes() {
    if (!this.transction_type) {
      // Get Quote Types
      this.quoteService.getQuoteTypes(1)
        .subscribe(
          (response: any) => {
            if (response.success) {
              this.transction_type = response.result.types[this.quote.type];
            }
          },
          (error) => {
            ;
          }
        );
    }
  }
}
